import Input from "../../../components/FormComponents/Input";
import SingleSelectBox from "../../../components/FormComponents/SingleSelectBox";
import SmtpConfig from "./EmailProviders/SmtpConfig";
import GmailApiConfig from "./EmailProviders/GmailApiConfig";
import OutlookConfig from "./EmailProviders/OutlookConfig";
import AwsSesConfig from "./EmailProviders/AwsSesConfig";
import Textarea from "../../../components/FormComponents/Textarea";

// const []

const emailProvoderList = [
  { id: "smtp", name: "Smtp" },
  { id: "gmail_api", name: "Gmail Api" },
  { id: "outlook", name: "Outlook" },
  { id: "aws_ses", name: "Aws Ses" }
];

const EmailConnectorRenderer = ({ setConnectorData, connectorData }) => {
  const handleChange = (key, value) => {
    setConnectorData({
      ...connectorData,
      [key]: value
    });
  };
  const handleInputChange = (e) => {
    handleChange(e.target.name, e.target.value);
  };

  const renderProviderComponent = () => {
    switch (connectorData.provider) {
      case "smtp":
        return <SmtpConfig data={connectorData.smtp} onChange={(newSmtp) => handleChange("smtp", newSmtp)} />;
      case "gmail_api":
        return (
          <GmailApiConfig data={connectorData.gmail_api} onChange={(newGApi) => handleChange("gmail_api", newGApi)} />
        );
      case "outlook":
        return (
          <OutlookConfig data={connectorData.outlook} onChange={(newOutlook) => handleChange("outlook", newOutlook)} />
        );
      case "aws_ses":
        return <AwsSesConfig data={connectorData.aws_ses} onChange={(newSes) => handleChange("aws_ses", newSes)} />;
      default:
        return null;
    }
  };

  return (
    <div className={"m_auto d_flex flex_column gap_3 py_3"} style={{ maxWidth: "500px" }}>
      <Input
        value={connectorData.name}
        onChange={handleInputChange}
        name={"name"}
        placeholder={"Enter connector name"}
        label={"Connector Name"}
      />
      <Input
        value={connectorData.email}
        onChange={handleInputChange}
        name={"email"}
        placeholder={"Enter your email"}
        label={"Email address"}
      />
      <Textarea
        value={connectorData.description}
        onChange={handleInputChange}
        name={"description"}
        placeholder={"Enter your description"}
        label={"Description"}
      />

      <SingleSelectBox
        selectedData={connectorData.provider}
        options={emailProvoderList}
        onChange={(p) => handleChange("provider", p.id)}
        label={"Email Provider"}
      />
      {renderProviderComponent()}
    </div>
  );
};
export default EmailConnectorRenderer;
